import type { Team } from "~/context/AuthContext";

export const TEAM_SCOPED_SECTIONS = [
  "agents",
  "ai-visibility",
  "chats",
  "foundry",
  "keyword-clusters",
  "library",
  "new-chat",
  "settings",
  "shopping",
];

const TEAM_PREFIX_PATTERN = /^\/t\/[^/]+/;

export function teamSlug(team: Pick<Team, "id" | "domain">): string {
  const domainSlug = team.domain
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return domainSlug ? `${team.id}-${domainSlug}` : String(team.id);
}

export function parseTeamId(slug: string | undefined): number | null {
  const match = slug?.match(/^(\d+)(?:-|$)/);
  return match ? Number(match[1]) : null;
}

export function teamPath(
  team: Pick<Team, "id" | "domain"> | undefined,
  path: string
): string {
  const section = path.split(/[/?#]/)[1] ?? "";
  if (
    !team ||
    !path.startsWith("/") ||
    !TEAM_SCOPED_SECTIONS.includes(section)
  ) {
    return path;
  }
  return `/t/${teamSlug(team)}${path}`;
}

export function stripTeamPrefix(pathname: string): string {
  return pathname.replace(TEAM_PREFIX_PATTERN, "") || "/";
}
